import { render, staticRenderFns } from "./warehouse-providers.vue?vue&type=template&id=08b45e54"
import script from "./warehouse-providers.vue?vue&type=script&lang=js"
export * from "./warehouse-providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports